import { Map, List } from 'immutable'
import _get from 'lodash/get'
import { ROLE_AUTHENTICATED_USER } from '../../auth/roles'
import {
  SET_USER_PROCESSING,
  SET_USER_TO_NEW_USER,
  SET_USER,
  SET_PROFILES,
  SET_USER_ERROR,
  RESET_USER_BLOCK,
  RESET_USER_BLOCK_SUCCESS,
  RESET_USER_BLOCK_ERROR,
  SET_USER_FIELD,
  SET_USER_FIELD_VALIDATION_ERROR,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  CLEAR_USER_ERROR,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_USER_ENTITLEMENT_SUCCESS,
  UPDATE_USER_ENTITLEMENT_ERROR,
  CLEAR_USER_ENTITLEMENTS,
  CREATE_USER_ENTITLEMENT_ERROR,
  CREATE_USER_ENTITLEMENT_SUCCESS,
  SET_USER_LAST_TRANSACTION,
  SET_USER_GCSI_SUBSCRIPTION,
  SIMULATION_SET_DATA,
  SIMULATION_ERROR,
  ANONYMIZE_USER_DATA_SUCCESS,
  ANONYMIZE_USER_DATA_ERROR,
  SET_USER_HISTORY_DATA,
  UPDATE_USER_HISTORY_DATA,
  SET_USER_HISTORY_PROCESSING,
  GRANT_USER_BONUS_SUCCESS,
  GRANT_USER_BONUS_ERROR,
  CHANGE_ACCOUNT_OWNER_SUCCESS,
  CHANGE_ACCOUNT_OWNER_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  const profilesStoreKey = 'profiles'
  switch (type) {
    case SIMULATION_ERROR:
      return state.setIn([payload.storeKey, 'simulationError'], true)
    case SIMULATION_SET_DATA:
      return state.setIn(
        [payload.storeKey, 'simulationData'],
        Map({
          value: payload.value,
          path: payload.path,
        }),
      )
    case RESET_USER_BLOCK:
      return state.setIn([payload.storeKey, 'processing'], true)
    case SET_USER_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_TO_NEW_USER:
      return state.setIn(
        [payload.storeKey, 'data'],
        Map({
          newUser: true,
          status: 'active',
          user_roles: List([Map({ role: ROLE_AUTHENTICATED_USER })]),
          user_entitlements: List(),
        }),
      )
    case SET_USER_LAST_TRANSACTION:
      return state
        .setIn([payload.storeKey, 'data', 'lastTransaction'], _get(payload, 'data', Map()))
        .setIn([payload.storeKey, 'processing'], false)
    case SET_USER_GCSI_SUBSCRIPTION:
      return state
        .setIn(
          [payload.storeKey, 'data', 'gcsi_user', 'subscription'],
          _get(payload, 'data', Map()),
        )
        .setIn([payload.storeKey, 'processing'], false)
    case SET_USER:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            data: _get(payload, 'data', Map()),
            processing: false,
            error: null,
            message: null,
          }),
        ),
      )
    case SET_PROFILES:
      return state
        .setIn([profilesStoreKey, 'data'], _get(payload, 'data', List()))
        .setIn([profilesStoreKey, 'processing'], false)
    case SET_USER_ERROR:
      // TODO: ERROR messaging needs to be handled better
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            data: Map(),
            processing: false,
            error: payload.error,
            setUserError: true,
            message: payload.error.message,
          }),
        ),
      )
    case RESET_USER_BLOCK_SUCCESS:
      return state.update(payload.storeKey, (value) => {
        const data = value.get('data', Map())
        return value.merge(
          Map({
            data: data.merge(
              Map({
                status: 'active',
                blocked_until: null,
              }),
            ),
            processing: false,
            error: payload.error,
            message: 'Reset user block successful',
          }),
        )
      })
    case RESET_USER_BLOCK_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            processing: false,
            error: payload.error,
            message: null,
          }),
        ),
      )
    case SET_USER_FIELD:
      return state.update(payload.storeKey, (value) => {
        const data = value.get('data', Map())
        const mapItem = {}
        mapItem[payload.fieldName] = payload.fieldValue
        mapItem.formIsDirty = true
        return value.merge(
          Map({
            data: data.merge(Map(mapItem)),
          }),
        )
      })
    case SET_USER_FIELD_VALIDATION_ERROR:
      return state.update(payload.storeKey, (value) => {
        const data = value.get('data', Map())
        const mapItem = {}
        mapItem[`${payload.fieldName}ValidationError`] = payload.fieldError
        mapItem.formIsDirty = true
        return value.merge(
          Map({
            data: data.merge(Map(mapItem)),
          }),
        )
      })
    case CREATE_USER_SUCCESS:
      return state
    case CREATE_USER_ERROR:
      return state.setIn(['userDetail', 'error'], payload.error)
    case CLEAR_USER_ERROR:
      return state.setIn(['userDetail', 'error'], false)
    case UPDATE_USER_SUCCESS:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            data: _get(payload, 'data', Map()),
            processing: false,
            error: null,
            message: null,
          }),
        ),
      )
    case UPDATE_USER_ERROR:
      return state.setIn(['userDetail', 'error'], payload.error)
    case UPDATE_USER_ENTITLEMENT_SUCCESS:
      return state
        .setIn(['userDetail', 'entitlementSuccess'], true)
        .setIn(['userDetail', 'data', 'user_entitlements', 0], payload.data.get('entitlement'))
    case UPDATE_USER_ENTITLEMENT_ERROR:
      return state.setIn(['userDetail', 'entitlementsError'], payload.error)
    case CREATE_USER_ENTITLEMENT_SUCCESS:
      return state.update('userDetail', (userDetail) => {
        const { data } = payload
        const entitlements = userDetail.getIn(['data', 'user_entitlements'])
        const newEntitlement = Map(data.get('entitlement'))
        const newList = entitlements.unshift(newEntitlement)
        return userDetail
          .set('entitlementSuccess', true)
          .setIn(['data', 'user_entitlements'], newList)
      })
    case CREATE_USER_ENTITLEMENT_ERROR:
      return state.setIn(['userDetail', 'entitlementsError'], payload.error)
    case CLEAR_USER_ENTITLEMENTS:
      return state
        .setIn(['userDetail', 'entitlementsError'], null)
        .setIn(['userDetail', 'entitlementSuccess'], null)
    case ANONYMIZE_USER_DATA_SUCCESS:
      return state
        .setIn(['userDetail', 'anonymizeSuccess'], true)
        .setIn(['userDetail', 'data', 'anonymizedValues'], payload.data)
    case ANONYMIZE_USER_DATA_ERROR:
      return state
        .setIn(['userDetail,', 'anonymizeSuccess'], false)
        .setIn(['userDetail', 'anonymizeError'], payload.error)
    case GRANT_USER_BONUS_SUCCESS:
      return state
        .setIn(['userDetail', 'grantUserBonusSuccess'], true)
        .setIn(['userDetail', 'data', 'grantUserBonusValues'], payload.data)
    case GRANT_USER_BONUS_ERROR:
      return state
        .setIn(['userDetail,', 'grantUserBonusSuccess'], false)
        .setIn(['userDetail', 'grantUserBonusError'], payload.error)
    case SET_USER_HISTORY_PROCESSING:
      return state.setIn(['userHistory', 'processing'], payload.processing)
    case SET_USER_HISTORY_DATA:
      return state
        .setIn(['userHistory', 'processing'], payload.processing)
        .setIn(['userHistory', 'data'], payload.data)
    case UPDATE_USER_HISTORY_DATA:
      return state
        .updateIn(['userHistory', 'data'], Map(), (data) => {
          if (data.isEmpty()) {
            return payload.data
          }
          return payload.data.updateIn(['records'], List(), (records) =>
            data.get('records').concat(records),
          )
        })
        .setIn(['userHistory', 'processing'], payload.processing)
    case CHANGE_ACCOUNT_OWNER_SUCCESS:
      return state
        .setIn(['userDetail', 'changeAccountOwnerSuccess'], true)
        .setIn(['userDetail', 'changeAccountOwnerError'], null)
        .setIn(['userDetail', 'changeAccountOwnerData'], payload.data)
    case CHANGE_ACCOUNT_OWNER_ERROR:
      return state
        .setIn(['userDetail', 'changeAccountOwnerSuccess'], false)
        .setIn(['userDetail', 'changeAccountOwnerError'], payload.error)
        .setIn(['userDetail', 'changeAccountOwnerData'], null)
    default:
      return state
  }
}
